import CommonMiddleware from 'yoda-site-components/lib/middlewares/CommonMiddleware';
import MiniPDPAnalyticsMiddleware from 'yoda-mini-pdp/lib/middlewares/MiniPDPAnalyticsMiddleware';
import CouponMiddleware from './CouponMiddleware';

const rootMiddleware = [CommonMiddleware, CouponMiddleware, MiniPDPAnalyticsMiddleware];

export default rootMiddleware;
